import {Controller} from "@hotwired/stimulus"

export default class extends Controller {
    connect() {
        $(this.element).select2({
            theme: "bootstrap-5",
        })
        $(this.element).on('select2:select', function () {
            console.log('aaa')
            let event = new Event('change', {bubbles: true}) // fire a native event
            this.dispatchEvent(event);
        });
    }
}